<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-11 08:57:14
 * @LastEditTime : 2023-11-07 11:23:27
 * @LastEditors  : yangxr
 * @Description  : 退货任务
 * @FilePath     : \icps_change\src\views\platform\ICPS\GHnumber\returnGoodsTask.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">车牌号</span>
              <el-input v-model="tableParam.carNo" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">原物料供应商</span>
              <el-input v-model="tableParam.supplier" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">站点名称</span>
              <el-input v-model="tableParam.stationName" style="width: 20%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">原物料名称</span>
              <el-input v-model="tableParam.rawName" style="width: 20%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="$router.push('GHnumberGoods')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <div v-if="item.label == '第一次过磅照片'">
                      <el-button size="mini" class="bottom_one" @click="look1Fun(scope.row.firstPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '第二次过磅照片'">
                      <el-button size="mini" class="bottom_one" @click="look1Fun(scope.row.secondPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '状态'">
                      <span>{{ dataStatusList[scope.row.dataStatus * 1] }}</span>
                    </div>
                    <div v-else-if="item.label == '操作'">
                      <el-button v-if="scope.row.secondTime && scope.row.dataStatus != 4" size="mini" class="bottom_one" @click="writeOff(scope.row)">冲销</el-button>
                      <el-button v-if="!scope.row.secondTime" size="mini" class="bottom_two" style="margin-left: 10px" @click="deleteTask(scope.row.id)"> 删除 </el-button>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="writeOffDig" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 冲销 </span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" hide-required-asterisk>
          <el-form-item>
            <span slot="label">冲销备注</span>
            <el-input v-model="fromDate.remark" :rows="5" resize="none" style="width: 320px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="writeOffDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveWriteOff()">确 定</el-button>
      </span>
    </el-dialog>
    <lookPicture :visible.sync="lookPictureDig" :urlList="urlList" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, deleteTask, backTask } from "@/api/GHnumber/returnGoodsTask.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  components: {
    lookPicture: () => import("@/components/File/lookPicture.vue"),
  },
  data() {
    return {
      disabledType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      loading: false,
      /*表格数据*/
      table: [
        {
          label: "任务编号",
          width: "",
          prop: "id",
          status: true,
        },
        {
          label: "采购任务编号",
          width: "",
          prop: "consimentId",
          status: true,
        },
        {
          label: "车牌号",
          width: "",
          prop: "carNo",
          status: true,
        },
        {
          label: "站点名称",
          width: "",
          prop: "stationName",
          status: true,
        },
        {
          label: "原物料",
          width: "",
          prop: "rawName",
          status: true,
        },
        {
          label: "规格",
          width: "",
          prop: "specification",
          status: true,
        },
        {
          label: "原物料供应商",
          width: "",
          prop: "supplier",
          status: true,
        },
        {
          label: "原物料运输商",
          width: "",
          prop: "transportSupplier",
          status: true,
        },
        {
          label: "备注",
          width: "",
          prop: "remark",
          status: true,
        },
        {
          label: "创建时间",
          width: "",
          prop: "createTime",
          status: true,
        },
        {
          label: "第一次过磅时间",
          width: "",
          prop: "firstTime",
          status: true,
        },
        {
          label: "第一次过磅量（吨）",
          width: "",
          prop: "firstWeight",
          status: true,
        },
        {
          label: "第一次过磅照片",
          width: "",
          prop: "firstPictureUrl",
          status: true,
        },
        {
          label: "第二次过磅时间",
          width: "",
          prop: "secondTime",
          status: true,
        },
        {
          label: "第二次过磅量（吨）",
          width: "",
          prop: "secondWeight",
          status: true,
        },
        {
          label: "第二次过磅照片",
          width: "",
          prop: "secondPictureUrl",
          status: true,
        },
        {
          label: "退货量",
          width: "",
          prop: "rerutnGoodNum",
          status: true,
        },
        {
          label: "状态",
          width: "",
          prop: "dataStatus",
          status: true,
        },
        {
          label: "冲销备注",
          width: "",
          prop: "remark",
          status: true,
        },
        {
          label: "操作",
          width: "240",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      fromDate: {
        carNo: "",
        stationId: "",
        stationName: "",
        rawId: "",
        rawName: "",
        warehouseId: "",
        warehouseName: "",
        shipTo: "",
        supplementaryOrdersStatus: "",
      },
      startTimDateEndTimDate: [],
      stationIdlist: [],
      urlList: [],
      lookPictureDig: false,
      dataStatusList: ["", "装料中（新任务）", "运输中（一次过磅后）", "已完成（二次过磅后）", "冲销"],
      isUpdate: false,
      writeOffDig: false,
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.stationIdlist = await getUserAutList(true);
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, dataSource: 1, supplier: "", stationName: "", rawName: "", startTime: "", endTime: "" };
    this.gettableData();
  },
  methods: {
    saveWriteOff() {
      backTask(this.fromDate).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.gettableData();
          this.writeOffDig = false;
        }
      });
    },
    writeOff(row) {
      this.fromDate = Object.assign({}, this.fromDate, row);
      this.writeOffDig = true;
    },
    look1Fun(e) {
      this.lookPictureDig = true;
      this.urlList = e ? e.split(",") : [];
      this.urlList.forEach((item, index) => {
        this.urlList[index] = "/file/" + item;
      });
    },
    deleteTask(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteTask({ id: id }).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    init() {
      /*重置数据*/
      this.tableParam = { ...this.tableParam, dataSource: 1, supplier: "", stationName: "", rawName: "", startTime: "", endTime: "" };
      this.gettableData();
    },
    submit() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_top {
  color: #008000;
}
.table_top:hover {
  color: #008000 !important;
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 320px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    background: #ffffff;
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.no-data {
  text-align: center;
}
.FZY ::v-deep .el-input-group__append {
  padding: 0px 8px;
}
.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}
</style>